import { render, staticRenderFns } from "./SidebarSeriesList.vue?vue&type=template&id=6fb317af"
import script from "./SidebarSeriesList.vue?vue&type=script&lang=js"
export * from "./SidebarSeriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports